import type { PvKostenRechnerValues } from '../components/shared/PvKostenRechnerWidget'

const STORAGE_KEY = 'solarbid.pendingRequestPrefill'
/** Grobe Lebensdauer eines Registrierungs-Aktivierungslinks - verhindert, dass ein wochenalter,
 *  nie fertig registrierter Versuch plötzlich wieder auftaucht. */
const TTL_MS = 60 * 60 * 1000

interface StoredPrefill {
  values: PvKostenRechnerValues
  expiresAt: number
}

/**
 * Überbrückt PLZ/kWp/Speicher aus dem PV-Kostenrechner über eine Registrierung hinweg
 * (tasks/new-things/preis-durchschnittsrechner/04-cta-prefill-deep-link.md). localStorage statt
 * sessionStorage (abweichend von der ursprünglichen Empfehlung im Task) - eine per E-Mail
 * verschickte Aktivierungslink wird von den meisten Mail-Clients/Browsern in einem NEUEN Tab
 * geöffnet, der kein sessionStorage mit dem Registrierungs-Tab teilt; localStorage überlebt genau
 * diesen (realistischen) Fall, bleibt aber wie sessionStorage auf denselben Browser/dasselbe Gerät
 * beschränkt.
 */
export function storeRequestPrefill(values: PvKostenRechnerValues): void {
  try {
    const entry: StoredPrefill = { values, expiresAt: Date.now() + TTL_MS }
    localStorage.setItem(STORAGE_KEY, JSON.stringify(entry))
  } catch {
    // Prefill ist ein Komfort-Feature, kein Blocker - z. B. im privaten Browser-Modus darf das
    // Fehlschlagen von localStorage die Registrierung selbst nicht stören.
  }
}

/** Liest den gespeicherten Prefill und löscht ihn sofort (auch wenn abgelaufen/kaputt) - ein
 *  Prefill darf nur genau einmal angewendet werden. */
export function consumeRequestPrefill(): PvKostenRechnerValues | null {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    localStorage.removeItem(STORAGE_KEY)
    if (!raw) return null
    const parsed = JSON.parse(raw) as StoredPrefill
    if (parsed.expiresAt < Date.now()) return null
    return parsed.values
  } catch {
    return null
  }
}
